/** The product nouns the integrations catalog + synthesized descriptions embed. */
export type IntegrationTaxonomyTerms = {
  customersPlural: string;
  customerSingular: string;
  campaignsPlural: string;
  peoplePlural: string;
};

/** The product nouns the integrations list needs. */
export function useProductTaxonomyTerms(): IntegrationTaxonomyTerms {
  return {
    customersPlural: 'profiles',
    customerSingular: 'profile',
    campaignsPlural: 'automations',
    peoplePlural: 'people',
  };
}
